export default function getPaletteColors(total) {
    const colors = ['#4E89FF', '#FFC044', '#72F093', '#FF7960', '#6944FF', '#FFE746', '#44A9EE', '#EE7FC9', '#44E5FF',
        '#FF9346', '#6BF9B9', '#F37BFF', '#C6E86F', '#4450EE', '#EEA445', '#9FF072', '#EEC745', '#D146FF', '#F88579',
        '#77DF75'];

    if (total <= colors.length) {
        return colors.slice(0, total);
    }

    const replicateArray = (sourceArray, numberOfCopies) => Array.from({length: numberOfCopies}, () => sourceArray).flat();
    let allColors = replicateArray(colors, Math.floor(total/colors.length));
    allColors.push(...colors.slice(0, total % colors.length));

    return allColors;
}
